import * as React from "react";
var Loading = function () {
    return (React.createElement("div", { style: { textAlign: "center" } },
        React.createElement("img", { height: "200px", width: "200px", src: "https://storage.googleapis.com/stratus-gg.appspot.com/loading.gif" })));
};
export default Loading;
